import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import HeaderHelmet from '../ui/HeaderHelmet';
import PrivacyUa from './PrivacyUa';
import PrivacyEn from './PrivacyEn';
import { privacyPath } from '../../utils/constants';

const Privacy = () => {
    const { i18n } = useTranslation();
    const isUa = i18n.language === 'ua';

    return (
        <>
            <HeaderHelmet name='privacyTitle' />
            <Helmet>
                <link rel="canonical" href={`https://lestro.com${privacyPath(i18n.language)}`} />
                <link rel="alternate" hrefLang="uk" href={`https://lestro.com${privacyPath('ua')}`} />
                <link rel="alternate" hrefLang="en" href={`https://lestro.com${privacyPath('en')}`} />
            </Helmet>

            <section className="privacy-page" lang={isUa ? 'uk' : 'en'}>
                <div className="container">
                    {isUa ? <PrivacyUa /> : <PrivacyEn />}
                </div>
            </section>
        </>
    );
};

export default Privacy;
